//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    countDisabled: {
      type: Boolean,
      default: false,
    },
    deliveryInfo: {
      type: Object,
      default: undefined,
    },
  },

  methods: {
    countChange(item, count) {
      item.count = count

      this.$emit('change', item)
    },
  },
}
